// extracted by mini-css-extract-plugin
export default {"Content":"miniCard_Content__5wnWp","Text":"miniCard_Text__6eDP0"};